import type { Rect } from "@yjsgames/phaser-ui/panel-content";

/**
 * point(scene world 좌표)가 슬롯 행 영역(slotsRow) 안에 있는지 — Phaser 비의존 순수 함수.
 * 드래그 드롭 등록/해제 판정의 SSoT: 그리드 셀을 슬롯 행에 드롭하면 등록, 채워진 슬롯을 행 밖으로
 * 드롭하면 해제. 슬롯/포인터가 동일 scene world 좌표계라 좌표 변환 없이 rect∩point 단순 비교로 충분하다.
 * 경계 접촉 포함(inclusive) — 슬롯 행 가장자리에 정확히 떨어뜨려도 안쪽으로 본다.
 */
export function isInsideSlotsRow(slotsRow: Rect, px: number, py: number): boolean {
  return (
    px >= slotsRow.x &&
    px <= slotsRow.x + slotsRow.width &&
    py >= slotsRow.y &&
    py <= slotsRow.y + slotsRow.height
  );
}
